import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchSnapshotData } from 'store/modules/housing/actions'
import SnapshotComponent from 'bundles/Dashboard/components/SnapshotComponent'

class SnapshotContainer extends Component {

    componentDidMount() {
        const { snapshotData, fetchSnapshotData } = this.props;

        if (!snapshotData) {
            fetchSnapshotData();
        }
    }

    render() {
        const { isFetchingSnapshot, snapshotData } = this.props;

        return (
           <SnapshotComponent
                data={snapshotData}
                isFetching={isFetchingSnapshot}
           />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        error: state.housing.error,
        isFetchingSnapshot: state.housing.isFetchingSnapshot,
        snapshotData: state.housing.snapshotData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchSnapshotData: () => {
            dispatch(fetchSnapshotData())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SnapshotContainer)